export default __webpack_public_path__ + "static/media/Reportes-orange.80f47955.svg";